import { render, staticRenderFns } from "./ProjectSignupForm.vue?vue&type=template&id=a2beda0e"
import script from "./ProjectSignupForm.vue?vue&type=script&lang=js"
export * from "./ProjectSignupForm.vue?vue&type=script&lang=js"
import style0 from "./ProjectSignupForm.vue?vue&type=style&index=0&id=a2beda0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports